import { render, staticRenderFns } from "./TableRiskAppraisalEp.vue?vue&type=template&id=7c892269&scoped=true"
import script from "./TableRiskAppraisalEp.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp.vue?vue&type=style&index=0&id=7c892269&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c892269",
  null
  
)

export default component.exports